import { Card } from 'primereact/card';
import { FC } from 'react';
import SingleUnitCardData from './SingleUnitCardData';
import { CountPerTypes } from '../../models/SingleUnit';
import { Divider } from 'primereact/divider';

interface Props {
  skillsTypesInUnit: CountPerTypes;
}

const SingleUnitLeftColumn: FC<Props> = ({ skillsTypesInUnit }) => {
  return (
    <Card
      className="nc_card lg:!tw-p-6 !tw-p-2 !tw-border-solid !tw-border-[2px] !w-rounded-2xl !tw-border-neutral-300 !tw-bg-neutral-50 !tw-shadow-none"
      id="unitSkillCounts"
      pt={{
        content: {
          className: '!tw-pt-0',
        },
      }}
    >
      <div className="tw-flex lg:tw-flex-col tw-flex-row tw-gap-x-4 tw-justify-start">
        <>
          <h1 className="tw-font-sora tw-text-base tw-font-bold">
            {skillsTypesInUnit.types.map(t => t.count).reduce((a, b) => a + b, 0)} total skills
          </h1>
          <Divider className="tw-mx-0 lg:tw-block tw-hidden" />
          <Divider layout="vertical" className="tw-mx-0 lg:tw-hidden tw-block" />
        </>
        <div className="tw-flex lg:tw-flex-col tw-flex-row tw-gap-6">
          {skillsTypesInUnit.types.map(value => {
            return <SingleUnitCardData key={value.targetSkillType} value={value} />;
          })}
        </div>
      </div>
    </Card>
  );
};

export default SingleUnitLeftColumn;
